export default {
  apiBaseUrl: 'https://chloe-api.peoplescience.health/api/',
  socketUrl: 'https://chloe-api.peoplescience.health/',
  webUrl: 'https://chloe.peoplescience.health',
  appWebUrl: 'https://chloe-app.peoplescience.health',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  referralUrl: 'https://chloe.peoplescience.health/referrals/',
  fitbitWebClientId: '238QTG',
  fitbitAppClientId: '23RDN7',
  oAuthRedirectWebUri: 'https://chloe-app.peoplescience.health/*',
  oAuthRedirectAppUri: 'health.peoplescience.chloe2://MyStudiesScreen',
  ouraAppClientId: 'LEAMD4QJSOAXV6TJ',
  appcuesAppId: '49be6c2d-3fb9-435b-a8f2-671f2878552b',
  appcuesAccountId: '209423',
  googleFitScopes: [
    'https://www.googleapis.com/auth/fitness.sleep.read',
    'https://www.googleapis.com/auth/fitness.oxygen_saturation.read',
    'https://www.googleapis.com/auth/fitness.heart_rate.read'
  ],
  recaptchaSiteKey: '6LeQ5X8oAAAAAOHqrSEfNX73lOB_IWcZRGTI2BpD',
  googleTagManagerId: 'GTM-TP4P4FQ'
};
